import { atom } from "nanostores";

export const isCookieSettingsOpen = atom(false);
export const isChatOnDemandTriggerVisible = atom(true);
